// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__qYJHS","tab":"ProcedureTabs_tab__1BzHN"};